import { APP_LOGOS, logoStyle } from '../ui/icons/appLogos';
import { waadooIcons } from '../ui/icons/waadooIcons';
import type { CardLogo } from './cardPresentation';

const DeleteIcon = waadooIcons.delete;
const TemplateIcon = waadooIcons.template;
const SoonIcon = waadooIcons.add;

/**
 * A tile's logo (`.waadoo-create-logo`, mockup « D1 », 2026-10-19): the
 * application's own (components/ui/icons/appLogos.ts), in its colour on a tint of it —
 * Odoo's from the theme's Odoo tokens —; the danger bin of a deletion; the
 * generic template glyph, or the « Bientôt » plus, on a neutral tile.
 * Decorative: the tile's title names the template.
 */
export function TemplateLogo(props: { logo: CardLogo | 'soon' }) {
  const { logo } = props;
  if (logo === 'delete' || logo === 'template' || logo === 'soon') {
    let Glyph = TemplateIcon;
    if (logo === 'delete') Glyph = DeleteIcon;
    else if (logo === 'soon') Glyph = SoonIcon;
    return (
      <span className="waadoo-create-logo" data-logo={logo} aria-hidden="true">
        <Glyph aria-hidden focusable="false" />
      </span>
    );
  }
  const app = APP_LOGOS[logo];
  return (
    <span
      className="waadoo-create-logo"
      data-logo={logo}
      style={logoStyle(logo)}
      aria-hidden="true"
    >
      {app.kind === 'path' ? (
        <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
          <path d={app.path} />
        </svg>
      ) : (
        <span className="waadoo-create-logo__letters">{app.letters}</span>
      )}
    </span>
  );
}
